import AuthUtils from './AuthUtils';
import store from '../store';
import { registerAuthToken, } from '../actions/auth';
import refreshAccessToken from './TokenRefresher';
import TokenRefreshManager from './TokenRefreshManager';

const storedToken = () => {
  const { auth = {}, } = store.getState();
  const { authentication = {}, } = auth;
  return authentication.token;
};

/**
 * Whether restoring the session needs a network round trip. Lets the UI skip its
 * placeholder for the common cases — no session at all, or one still valid.
 */
export const sessionNeedsRestore = () => {
  const token = storedToken();
  return !!token && !AuthUtils.isTokenValid(token);
};

/**
 * Decide what a stored session is worth at page load.
 *
 * An access token that expired while the tab was closed is still redeemable — the
 * refresh cookie outlives it — so try a silent refresh before asking the user for
 * anything. Only a refresh that actually fails clears the session and drops the
 * user on the login form.
 *
 * The lock screen is never raised here. That overlay exists to protect work in
 * progress, and a cold load has none; showing it at boot only makes the user
 * authenticate twice — once to unlock, once to log in.
 *
 * @returns {Promise<boolean>} whether a usable session survived
 */
const restoreSession = async () => {
  const token = storedToken();

  if (!token) {
    return false;
  }

  if (!AuthUtils.isTokenValid(token)) {
    try {
      await refreshAccessToken();
    } catch (error) {
      console.error('Could not restore session:', error);
      window.localStorage.removeItem('PAYIT_TOKEN');
      store.dispatch(registerAuthToken({}));
      return false;
    }
  }

  TokenRefreshManager.start();
  return true;
};

export default restoreSession;